/**
 * Configure the generated agents openapi-ts client.
 *
 * Import this module once (e.g. in main.tsx) to set the base URL
 * and register the auth interceptors. The generated SDK functions
 * and TanStack Query hooks will then use these settings automatically.
 */

import { client } from './generated-agents/client.gen';
import { AGENT_BASE } from '../config';
import { attachAuthInterceptors } from './attachAuthInterceptors';

client.setConfig({ baseUrl: AGENT_BASE, credentials: 'include' });
attachAuthInterceptors(client);

export { client };
